import { ALERT_CLEAR, ALERT_ERROR, ALERT_SUCCESS } from '../../../constants/alert.constants';
import { SuccessAction, ErrorAction, ClearAction } from '../../../models/redux/actions/alert.action';

export function success(message: string): SuccessAction {
  return {
    type: ALERT_SUCCESS,
    message,
  };
}

export function error(message: string): ErrorAction {
  return {
    type: ALERT_ERROR,
    message,
  };
}

export function clear(): ClearAction {
  return {
    type: ALERT_CLEAR,
  };
}
